import { render, staticRenderFns } from "./AvatarBuilderFashionCategory.vue?vue&type=template&id=3de29710&scoped=true&"
import script from "./AvatarBuilderFashionCategory.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderFashionCategory.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderFashionCategory.vue?vue&type=style&index=0&id=3de29710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de29710",
  null
  
)

export default component.exports